/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Fine_Print_WithdrawalsInputs */

const en_campaigns_mag7_fine_print_withdrawals = /** @type {(inputs: Campaigns_Mag7_Fine_Print_WithdrawalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdrawals are allowed at any time. There are no lockups.`)
};

const de_campaigns_mag7_fine_print_withdrawals = /** @type {(inputs: Campaigns_Mag7_Fine_Print_WithdrawalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abhebungen sind jederzeit möglich. Es gibt keine Sperrfristen.`)
};

const pt_br2_campaigns_mag7_fine_print_withdrawals = /** @type {(inputs: Campaigns_Mag7_Fine_Print_WithdrawalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saques são permitidos a qualquer momento. Não há período de bloqueio.`)
};

const tr_campaigns_mag7_fine_print_withdrawals = /** @type {(inputs: Campaigns_Mag7_Fine_Print_WithdrawalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstediğiniz zaman çekim yapabilirsiniz. Kilit süresi yoktur.`)
};

const zh_cn2_campaigns_mag7_fine_print_withdrawals = /** @type {(inputs: Campaigns_Mag7_Fine_Print_WithdrawalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可随时提取，无锁定期。`)
};

const zh_hk2_campaigns_mag7_fine_print_withdrawals = /** @type {(inputs: Campaigns_Mag7_Fine_Print_WithdrawalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可隨時提取，並無鎖倉期。`)
};

const ko_kr2_campaigns_mag7_fine_print_withdrawals = /** @type {(inputs: Campaigns_Mag7_Fine_Print_WithdrawalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언제든지 출금할 수 있으며, 예치 기간 제한은 없습니다.`)
};

const ru_ru2_campaigns_mag7_fine_print_withdrawals = /** @type {(inputs: Campaigns_Mag7_Fine_Print_WithdrawalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выводить средства можно в любой момент. Блокировок нет.`)
};

const es_419_campaigns_mag7_fine_print_withdrawals = /** @type {(inputs: Campaigns_Mag7_Fine_Print_WithdrawalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes retirar en cualquier momento. No hay períodos de bloqueo.`)
};

/**
* | output |
* | --- |
* | "Withdrawals are allowed at any time. There are no lockups." |
*
* @param {Campaigns_Mag7_Fine_Print_WithdrawalsInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_fine_print_withdrawals = /** @type {((inputs?: Campaigns_Mag7_Fine_Print_WithdrawalsInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Fine_Print_WithdrawalsInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_fine_print_withdrawals(inputs)
	if (locale === "de") return de_campaigns_mag7_fine_print_withdrawals(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_fine_print_withdrawals(inputs)
	if (locale === "tr") return tr_campaigns_mag7_fine_print_withdrawals(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_fine_print_withdrawals(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_fine_print_withdrawals(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_fine_print_withdrawals(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_fine_print_withdrawals(inputs)
	return es_419_campaigns_mag7_fine_print_withdrawals(inputs)
});